import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=53001f65&scoped=true"
import script from "./PageBase.vue?vue&type=script&lang=js"
export * from "./PageBase.vue?vue&type=script&lang=js"
import style0 from "./PageBase.vue?vue&type=style&index=0&id=53001f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53001f65",
  null
  
)

export default component.exports